import script from "./PurchaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseModal.vue?vue&type=style&index=0&id=657b9a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657b9a6c"]])

export default __exports__